@if (Error) {
  <mj-empty-state Variant="error" Title="Couldn't load this review" [Message]="Error"><div actions><button type="button" mjButton variant="primary" (click)="Refresh()">Try again</button></div></mj-empty-state>
} @else if (NoSeason) {
  <mj-empty-state Variant="empty" Title="OEP is between seasons" Message="There is no active OEP season yet. We will email you when your role opens." />
} @else if (NotFound) {
  <mj-empty-state Variant="empty" Title="This assignment isn't available" Message="If you expected it, reply to your OEP email or write to membership@agu.org."><div actions><button type="button" mjButton variant="primary" (click)="Back()">Back to your assignments</button></div></mj-empty-state>
} @else if (VM) {
<section class="oep-rev" [attr.aria-busy]="Busy">
  <!-- markup.html:558 -->
  <button type="button" class="oep-rev__back" (click)="Back()">← All draft reviews</button>

  <!-- markup.html:559-565: just submitted -->
  @if (VM.Submitted; as s) {
    <div class="oep-card oep-rev__done">
      <h1 class="oep-rev__h1">{{ s.Title }}</h1>
      <p>{{ s.Body }}</p>
      <button type="button" mjButton variant="primary" class="oep-rev__primary" (click)="Back()">Back to your assignments</button>
    </div>
  }

  <!-- markup.html:566-605: archive (submitted or window closed) -->
  @if (VM.Archive; as a) {
    <h1 class="oep-rev__h1">{{ VM.Title }}</h1>
    <p class="oep-rev__meta">@if (a.Section) {<span class="oep-rev__section">{{ a.Section }}</span> · }{{ a.Meta }}</p>
    <div class="oep-card oep-rev__card">
      @if (a.Empty) { <p class="oep-rev__empty">{{ a.Empty }}</p> }
      @if (a.Scores.length) {
      <ul class="oep-rev__scores" aria-label="Your scores">
        @for (s of a.Scores; track s.Label) {
          <li class="oep-rev__score"><strong>{{ s.Label }}</strong><span class="oep-rev__score-value">{{ s.Value }}</span></li>
        }
      </ul>
      }
      @for (t of a.Texts; track t.Label) {
        <div class="oep-rev__text">
          <h2 class="oep-eyebrow oep-rev__text-label">{{ t.Label }}</h2>
          <p>{{ t.Body }}</p>
        </div>
      }
      <div class="oep-rev__closed">{{ a.ClosedNote }}</div>
      <div class="oep-rev__thread-block">
        <h2 class="oep-rev__h2" id="oep-rev-thread">Conversation with your presenter</h2>
        <div class="oep-rev__thread-note" id="oep-rev-thread-note">{{ a.ThreadNote }}</div>
        @if (a.Thread.length) {
          <ol class="oep-rev__thread">
            @for (m of a.Thread; track $index) {
              <li class="oep-rev__bubble" [class.oep-rev__bubble--mine]="m.Mine"><strong>{{ m.Who }}</strong>{{ m.Body }}</li>
            }
          </ol>
        }
        @if (a.CanReply) {
          <textarea class="oep-textarea oep-rev__reply" id="oep-rev-reply" aria-labelledby="oep-rev-thread" aria-describedby="oep-rev-thread-note"
            [maxlength]="NoteMax" placeholder="Glad it helped. One more thought before the session…" [(ngModel)]="Reply" [readonly]="Busy" [attr.aria-busy]="Busy"></textarea>
          <button type="button" mjButton variant="primary" class="oep-rev__primary" [disabled]="!CanSendReply" (click)="SendReply()">Send reply</button>
        }
        <p class="oep-rev__status" role="status" aria-live="polite" [attr.data-tone]="ReplyStatus?.Tone">{{ ReplyStatus?.Text }}</p>
      </div>
    </div>
    <button type="button" mjButton variant="primary" class="oep-rev__primary oep-rev__after" (click)="Back()">Back to your assignments</button>
  }

  <!-- markup.html:607-657: editing -->
  @if (VM.Edit; as e) {
    <div class="oep-rev__grid">
      <div class="oep-rev__main">
        <h1 class="oep-rev__h1">{{ VM.Title }}</h1>
        <p class="oep-rev__meta">@if (e.Section) {<span class="oep-rev__section">{{ e.Section }}</span> · }{{ e.Meta }}</p>

        <div class="oep-card oep-rev__card">
          @for (b of e.Rubric; track b.QuestionID) {
            <div class="oep-rev__block" role="group" [attr.aria-labelledby]="b.HeadingID">
              <h2 class="oep-rev__q" [id]="b.HeadingID">{{ b.Label }} @if (b.Required) { <span class="oep-rev__req" aria-hidden="true">*</span> }</h2>
              @if (b.Help) { <div class="oep-rev__help" [id]="b.HeadingID + '-help'">{{ b.Help }}</div> }
              <agu-scale-choice [Options]="b.Options" [Value]="Answers[b.QuestionID].Level" [Name]="b.Name" [LabelledBy]="b.HeadingID" [Required]="b.Required" [Disabled]="Busy" (ValueChange)="Pick(b.QuestionID, $event)" />
              <span class="oep-rev__sr" [id]="b.HeadingID + '-comment'">Comment</span>
              <textarea class="oep-textarea oep-rev__comment" [attr.aria-labelledby]="b.HeadingID + ' ' + b.HeadingID + '-comment'" [attr.aria-describedby]="b.Help ? b.HeadingID + '-help' : null" [attr.aria-required]="b.Required"
                placeholder="Describe what the presenter did well and what the presenter could improve." [(ngModel)]="Answers[b.QuestionID].Text" [readonly]="Busy" [attr.aria-busy]="Busy"></textarea>
            </div>
          }
          <p class="oep-rev__lead">{{ e.WrittenIntro }}</p>
          @if (e.Strengths; as t) {
            <div class="oep-rev__block">
              <h2 class="oep-rev__q" [id]="t.HeadingID">{{ t.Label }} @if (t.Required) { <span class="oep-rev__req" aria-hidden="true">*</span> }</h2>
              @if (t.Help) { <div class="oep-rev__help" [id]="t.HeadingID + '-help'">{{ t.Help }}</div> }
              <textarea class="oep-textarea oep-rev__strengths" [attr.aria-labelledby]="t.HeadingID" [attr.aria-describedby]="t.Help ? t.HeadingID + '-help' : null" [attr.aria-required]="t.Required"
                [placeholder]="t.Placeholder" [(ngModel)]="Answers[t.QuestionID].Text" [readonly]="Busy" [attr.aria-busy]="Busy"></textarea>
            </div>
          }
          @if (e.Additional; as t) {
            <div class="oep-rev__block oep-rev__block--last">
              <h2 class="oep-rev__q" [id]="t.HeadingID">{{ t.Label }} <span class="oep-rev__optional">(optional)</span></h2>
              @if (t.Help) { <div class="oep-rev__help" [id]="t.HeadingID + '-help'">{{ t.Help }}</div> }
              <textarea class="oep-textarea oep-rev__additional" [attr.aria-labelledby]="t.HeadingID" [attr.aria-describedby]="t.Help ? t.HeadingID + '-help' : null"
                [placeholder]="t.Placeholder" [(ngModel)]="Answers[t.QuestionID].Text" [readonly]="Busy" [attr.aria-busy]="Busy"></textarea>
            </div>
          }
          <div class="oep-rev__actions">
            <button type="button" mjButton variant="primary" class="oep-rev__submit" [disabled]="!CanSubmit" (click)="Save(true)">Submit feedback</button>
            <button type="button" mjButton variant="outline" class="oep-rev__save" [disabled]="Busy" (click)="Save(false)">{{ SaveLabel }}</button>
          </div>
          <p class="oep-rev__status" role="status" aria-live="polite" [attr.data-tone]="FormStatus?.Tone">{{ FormStatus?.Text }}</p>
        </div>
      </div>

      <!-- markup.html:629-657 -->
      <aside class="oep-rev__aside" aria-label="The draft and reviewer guidance">
        <div class="oep-card oep-rev__draft">
          <div class="oep-rev__draft-head">
            <h2 class="oep-rev__draft-title">The draft</h2>
            @if (e.Draft) { <button type="button" class="oep-rev__link" (click)="OpenDraft()">Open full size</button> }
          </div>
          @if (e.Draft; as d) {
            @if (d.IsPdf && SafeDraftUrl) {
              <!-- No sandbox attribute: Chrome refuses to render a PDF in ANY sandboxed iframe (checked 2026-09-30 with a
                   cross-origin test PDF: sandbox="" and sandbox="allow-scripts allow-same-origin" both render the blocked-page
                   icon; no sandbox renders). Isolation comes from the frame being cross-origin (the storage host's signed URL,
                   https only, from OEPFilesService.DownloadUrl) and only application/pdf files being framed. -->
              <iframe class="oep-rev__viewer" [src]="SafeDraftUrl" title="Draft presentation" referrerpolicy="no-referrer" loading="lazy"></iframe>
            } @else {
              <div class="oep-rev__no-preview">Preview is available for PDF drafts. Use Open full size.</div>
            }
            <div class="oep-rev__file">{{ d.FileLine }}</div>
          } @else {
            <div class="oep-rev__no-preview">No draft uploaded</div>
          }
          <p class="oep-rev__status oep-rev__draft-status" role="status" aria-live="polite" [attr.data-tone]="DraftStatus?.Tone">{{ DraftStatus?.Text }}@if (DraftStatus?.Link; as l) { <a [href]="l.Url" target="_blank" rel="noopener">{{ l.Label }}<span class="oep-sr"> (opens in a new tab)</span></a> }</p>
        </div>
        <div class="oep-rev__guide">
          <h2 class="oep-rev__guide-title">Reviewer guidance</h2>
          {{ e.Guidance.Text }}
          @if (e.Guidance.Link; as g) { <a class="oep-rev__guide-link" [href]="g.Url" target="_blank" rel="noopener">Reviewer guidance (PDF)<span class="oep-sr"> (opens in a new tab)</span></a> }
        </div>
      </aside>
    </div>
  }
</section>
}
